import { User } from "@/domain/models";
import { defineStore } from "pinia";

export interface IState {
  session: User | null;
  token: string | null;
}

const getStateFromStorage = (): IState => {
  const localState = localStorage.getItem(
    process.env.VUE_APP_STORAGE_KEY as string
  );
  const st: IState = JSON.parse(localState || "{}");
  const state: IState = {
    session: st.session,
    token: st.token,
  };
  return state;
};

export const useMainStore = defineStore("main", {
  state: getStateFromStorage,
  // getters: {
  // getSession: (state) => state.session,
  // getToken: (state) => state.token,
  // },
  actions: {
    async saveToken(token: string) {
      this.$patch({ token });
      this.saveState();
    },
    async saveSession(session: User) {
      const newSession = { ...this.$state.session, ...session };
      this.$patch({ session: newSession });
      this.saveState();
    },
    clearSession() {
      this.$patch({ session: null, token: null });
      this.saveState();
    },
    saveState() {
      localStorage.setItem(
        process.env.VUE_APP_STORAGE_KEY as string,
        JSON.stringify(this.$state)
      );
    },
  },
});
